import React from 'react';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Cell from '../Cell';
import blueSemiTruckSvg from '../../../images/calendar/blueSemiTruck.svg';
import PropTypes from 'prop-types';
import { getStyleForShiftId } from '../../../libs/calendarConfig';

function styles() {
	return {
		container: {
			padding: '3px 6px',
		},
		blueSemiTruckIcon: {
			display: 'inline-block',
			width: 28,
			height: 28,
			backgroundImage: `url('${blueSemiTruckSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 2,
		},
		truckContainer: {
			display: 'flex',
			alignItems: 'center',
			fontWeight: 900,
			color: '#444',
		},
		subDisplay: {
			color: '#666',
			fontSize: 13,
			whiteSpace: 'noWrap',
		},
		geoTabComment: {
			fontSize: '85%',
			color: '#555',
			paddingLeft: 2,
			fontWeight: 400,
		},
		shiftTime: {
			fontSize: 14,
			textAlign: 'center',
			display: 'flex',
			alignItems: 'center',
		},
		shiftMarker: {
			width: 10,
			height: 10,
			border: '1px solid white',
			borderRadius: 20,
			marginRight: 2,
		},
	};
}

function ShiftCell(props) {
	const { key, classes, isOdd, shiftId, shiftTime } = props;
	let style = getStyleForShiftId({ shiftId, status: 'full' });
	return (
		<Cell isOdd={isOdd} key={key}>
			<div className={classes.container}>
				<div className={classes.shiftTime}>
					<div className={classes.shiftMarker} style={style} />
					{moment(`2020-01-01 ${shiftTime}`).format('HH:mm')}
				</div>
			</div>
		</Cell>
	);
}

ShiftCell.propTypes = {
	isOdd: PropTypes.number,
	shiftTime: PropTypes.string,
};

export default withStyles(styles)(ShiftCell);
